import React, { PropTypes } from "react";
import cx from "classnames";
import useSWR from "swr";
import { fetcher } from "./Overview/Overview";
import { Link } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { toggleSnugFit } from "../actions/userSettings";

// Display the usermenu in the top menu-bar. It is also used for displaying a global notification for messages
export function UserMenu(props) {
    const { data: totalMessages } = useSWR(() => `/v1/messages/?ordering=-publication_date&application=portaal.nibhv.nl`, fetcher);

    const totalMessageCount = totalMessages?.count;
    const newMessages = totalMessages?.results?.filter((o) => !o.read);
    const newMessageCount = newMessages?.length || 0;

    const dispatch = useDispatch();
    const snugFit = useSelector((state) => state?.UserSettingsState?.snugFit);

    return (
        <>
            <div className={cx("header-account toggle", { "header-account--open": props.accountOpen })}>
                <div className={"header-account__main"} onClick={props.toggleAccountOpen}>
                    {newMessageCount > 0 && <div className="header-account-notification notification-badge">{newMessageCount}</div>}
                    <div className="header-account-name">{props?.userName || "Gebruikersnaam"}</div>

                    <div className="header-account-company">{props?.userEmail || "E-mailadres"}</div>

                    <i className="header-account__chevron fa fa-angle-down" aria-hidden="true" />
                </div>
                {props.accountOpen && (
                    <ul className={"header-account-menu"}>
                        <li className={"header-account-menu__item header-account-menu__item--with-icon"}>
                            <span className={"header-account-menu__text"} onClick={() => dispatch(toggleSnugFit(snugFit))}>
                                Compacte weergave
                            </span>
                            <div className={"header-account-menu__icon"}>
                                <i
                                    className={cx("fa toggle-button", snugFit ? "fa-toggle-on" : "fa-toggle-off")}
                                    title="Deactiveren"
                                    onClick={() => dispatch(toggleSnugFit(snugFit))}
                                ></i>
                            </div>
                        </li>

                        <li className={"header-account-menu__item"}>
                            <Link to={"/news"} onClick={props.toggleAccountOpen}>
                                <span>Nieuwsarchief</span>
                                <div className={cx("notification-badge", { "notification-badge--inactive": newMessageCount === 0 })}>
                                    {newMessageCount > 0 ? newMessageCount : totalMessageCount}
                                </div>
                            </Link>
                        </li>
                        <li className={"header-account-menu__item"}>
                            <span className={"header-account-menu__text"} onClick={props.handleLogoutRequest}>
                                Uitloggen
                            </span>
                        </li>
                    </ul>
                )}
            </div>
        </>
    );
}
